<template>
  <div class="modal-wrapper" v-show="show">
    <div class="content">
      <slot></slot>
    </div>
<!--    <div class="close">-->
<!--      <img @click="handleHide" class="close-icon" src="../../assets/rain/close-white.png" alt="close">-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: "Modal",
  props:['defaultShow'],
  data() {
    return {
      show: false
    }
  },
  created() {
    this.show = this.defaultShow;
  },
  methods: {
    handleShow() {
      this.show = true;
    },
    handleHide() {
      this.show = false;
      this.$emit('hide')
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, .6);
  .content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .close {
    position: absolute;
    left: 50%;
    bottom: 100px;
    transform: translateX(-50%);
    .close-icon {
      width: 30px;
    }
  }
}
</style>
